import { Box } from "@mui/material";
import Link from "next/link";

export type SidebarProps = {
  sidebar: any
}

export default function Sidebar(props: SidebarProps) {
  const { sidebar } = props;
  const { attributeName, connectedName, sku } = sidebar;

  const title = attributeName;
  const link = connectedName;
  const href = sku;

  return (
    <Box sx={{ paddingTop: 2, display: 'flex' }}>
      <Box sx={{ pr: 1 }}>
        {title}
      </Box>
      <Link href={href} style={{ textDecoration: 'none' }}>
        <Box
          sx={(theme) => ({
            color: theme.palette.primary.main
          })}>
          {link}
        </Box>
      </Link>
    </Box>
  );

}